// --- API for PlacKrakowski ---
const API_URL = 'https://publictwin.info/EngagementAppPrototypes/PlacKrakowskiPHP';

// DOM
const answersGrid = document.getElementById('answers-grid');
const loadingScreen = document.getElementById('answers-loading-screen');
const ageForm = document.getElementById('age-admin-form');
const genderForm = document.getElementById('gender-admin-form');
const relationForm = document.getElementById('relation-admin-form');
const zoneForm = document.getElementById('zone-admin-form');
const configForm = document.getElementById('config-admin-form');

const shownAnswersSpan = document.getElementById('shown-answers-span');
const allAnswersSpan = document.getElementById('all-answers-span');
const sortSelect = document.getElementById('date-sort-select');
const noAnswersDiv = document.getElementById('no-answers-admin');
const resetFiltersButton = document.getElementById('reset-filters-button');

import Shuffle from 'shufflejs';
import openEditPanel, { refreshEditPanel } from "./editPanel.js";

function showLoadingScreen(){ loadingScreen.classList.remove('hidden'); answersGrid.classList.add('hidden'); }
function hideLoadingScreen(){ loadingScreen.classList.add('hidden'); answersGrid.classList.remove('hidden'); shuffleInstance?.update(); }

let answerData = [];
let shuffleInstance = null;

function fetchAnswers(options = {}) {
  fetch(`${API_URL}/Get_Answers_PlacKrakowski.php`)
    .then(r => r.json())
    .then(data => {
      renderAnswers(data);
      options.callback?.(data);
    })
    .catch(err => console.error('Błąd pobierania odpowiedzi:', err));
}

sortSelect?.addEventListener('change', (e) => {
  currentSort = e.target.value;
  sortAnswers();
});
let currentSort = sortSelect?.value || 'new-to-old';

const filters = {
  age:      ageForm?.value || "wszystkie",
  gender:   genderForm?.value || "wszystkie",
  relation: relationForm?.value || "wszystkie",
  zone:     zoneForm?.value || "wszystkie",
  config:   configForm?.value || "wszystkie",
};

const filterForms = [ageForm, genderForm, relationForm, zoneForm, configForm].filter(Boolean);
filterForms.forEach(form => {
  form.addEventListener('change', (e) => {
    filters[form.dataset.filterValue] = e.target.value;
    filterAnswers();
  });
});

resetFiltersButton.addEventListener('click', () => {
  filterForms.forEach(form => {
    form.value = 'wszystkie';
    filters[form.dataset.filterValue] = 'wszystkie';
  });
  filterAnswers();
});

function sortAnswers() {
  if (currentSort === 'new-to-old') {
    shuffleInstance.sort({ by: el => new Date(el.dataset.created_at), reverse: true });
  } else {
    shuffleInstance.sort({ by: el => new Date(el.dataset.created_at) });
  }
}

const standardFormAnswers = {
  gender: ["kobieta", "mężczyzna", "wolę nie podawać"],
  relation: ["mieszkaniec okolicy", "mieszkaniec miasta"]
};

function isFilteredOut(element, filterName) {
  const cur = filters[filterName];
  const val = element.dataset[filterName];
  if (cur === 'wszystkie') return false;

  // for relation “inne”
  if (filterName === 'relation' && cur === 'inne') {
    return standardFormAnswers.relation.includes(val); // show only those NOT in standard list
  }
  return val !== cur;
}

function filterAnswers() {
  shuffleInstance.filter(el => {
    if (isFilteredOut(el, 'age')) return false;
    if (isFilteredOut(el, 'gender')) return false;
    if (isFilteredOut(el, 'relation')) return false;
    if (isFilteredOut(el, 'zone')) return false;
    if (isFilteredOut(el, 'config')) return false;
    return true;
  });

  shownAnswersSpan.textContent = shuffleInstance.sortedItems.length;
  allAnswersSpan.textContent = answerData.length;
  noAnswersDiv.classList.toggle('hidden', shuffleInstance.sortedItems.length > 0);
}

function getAnswerGroup(allAnswers, targetAnswer) {
  // For Plac we likely don’t have scan_image groups; just return the single
  return [targetAnswer];
}

const QUESTIONS_PL = [
  "Pytanie 1",
  "Pytanie 2",
  "Pytanie 3",
];

function renderAnswers(newData) {
  answerData = newData || [];

  answersGrid.innerHTML = '';
  hideLoadingScreen();

  answerData.forEach(item => {
    const div = document.createElement('div');
    div.classList.add('answer-item');

    // datasets for filters
    div.dataset.created_at = item.created_at;
    div.dataset.age      = item.edited_age_group ?? item.age_group ?? '-';
    div.dataset.gender   = item.edited_gender ?? item.gender ?? '-';
    div.dataset.relation = item.edited_relation_to_place ?? item.relation_to_place ?? '-';
    div.dataset.zone     = String(item.zone_id || '0');         // "1".."5"
    div.dataset.config   = String(item.configuration_id || '0'); // "1".."5"

    div.addEventListener('click', () => {
      openEditPanel([item], () => {
        fetchAnswers({ callback: (fresh) => {
          const updated = fresh.find(a => a.id === item.id);
          if (updated) refreshEditPanel([updated]);
        }});
      });
    });

    // Left: participant data
    const userDataDiv = document.createElement('div');
    userDataDiv.classList.add("user-data");
    userDataDiv.innerHTML = `
      <img class="CheckboxMainMenuIcon"
           src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/PersonIcon.svg" />
      ${div.dataset.gender} (${div.dataset.age}), ${div.dataset.relation}
    `;

    // Middle: Q/A
    const answerDataDiv = document.createElement('div');
    answerDataDiv.classList.add("answer-data");

    // For Plac we may not use question_id; show a simple label:
    answerDataDiv.innerHTML += `<div><b>Odp.:</b> ${item.edited_text ?? item.answer_text}</div>`;

    const catsCSV = (item.edited_categories ?? item.categories ?? '').trim();
    const cats = catsCSV ? catsCSV.split(',').map(s => s.trim()) : [];
    const categoriesDiv = document.createElement('div');
    categoriesDiv.classList.add("answer-categories");
    cats.forEach(c => categoriesDiv.innerHTML += `<div class="category">${c}</div>`);

    // Right: meta (zone / config / date)
    const infoDiv = document.createElement('div');
    infoDiv.classList.add("answer-info", "flex-row");
    infoDiv.innerHTML =
      `<div>Strefa: <b>${div.dataset.zone}</b></div>
       <div>Konfiguracja: <b>${div.dataset.config}</b></div>
       <div class="date-div">Data: <b>${item.created_at}</b></div>`;

    answerDataDiv.appendChild(categoriesDiv);
    div.appendChild(userDataDiv);
    div.appendChild(answerDataDiv);
    div.appendChild(infoDiv);
    answersGrid.appendChild(div);

    item.domElement = div;
  });

  if (!shuffleInstance) {
    shuffleInstance = new Shuffle(answersGrid, { itemSelector: '.answer-item', sizer: '.answer-sizer' });
  } else {
    shuffleInstance.resetItems();
  }

  filterAnswers();
  sortAnswers();
}

export default function openAdminPanel() {
  showLoadingScreen();
  fetchAnswers();
}
